var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addOnFeaturesReview",attrs:{"data-test-id":_vm.$testId('container')}},[_c('InputLabel',{attrs:{"text":_vm.subHeader}}),_vm._l((_vm.selectedAddOns),function(addOn,index){return _c('div',{key:index,attrs:{"data-test-id":`selectedAddOns__${index}`}},[_c('ParagraphBody',[_vm._v(" "+_vm._s(addOn.displayName)+" ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }